/**
 * External dependencies
 */
import React from 'react';
import { graphql } from 'gatsby';

/**
 * Internal dependencies
 */
import { Page, ProductImageBackground, Link, ProductCard } from '../components';

export default class extends React.Component {
  render() {
    const { data } = this.props;
    const mens = data.mens.edges;
    const mensClothing = data.mensClothing.edges;
    const womensJeans = data.womensJeans.edges;

    return (
      <Page className={'HomePage'} title={'Home'}>
        <header className="main_banner">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="video_container">
                  <Link to="/category/mens">
                    <ProductImageBackground
                      uri={'c155990-1000.jpg'}
                      size={'cover'}
                      width={'100%'}
                      height={`380px`}
                    />
                    <h1>Men's</h1>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="video_container">
                  <Link to="/category/womens">
                    <ProductImageBackground
                      uri={'3003041_ALT-1000.jpg'}
                      size={'cover'}
                      width={'100%'}
                      height={`380px`}
                    />
                    <h1>Women's</h1>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </header>

        <section
          className="featured"
          style={{ paddingTop: '30px', paddingBottom: '130px' }}
        >
          <div className="container">
            <div className="featured_videos">
              <h3>New Arrivals</h3>
              <div className="row">
                {[mens[3], womensJeans[1], mensClothing[0], womensJeans[0]].map(
                  (node, index) => {
                    return <ProductCard key={index} product={node.node} />;
                  }
                )}
              </div>
            </div>
            <div className="featured_videos">
              <h3>Featured Products</h3>
              {[womensJeans[3], mens[4], womensJeans[4], mensClothing[1]].map(
                (node, index) => {
                  return <ProductCard key={index} product={node.node} />;
                }
              )}
            </div>
          </div>
        </section>
      </Page>
    );
  }
}

export const pageQuery = graphql`
  query {
    womensJeans: allProduct(
      sort: { fields: categories, order: ASC }
      filter: { categories: { regex: "/(^womens)|(^jeans)/gi" } }
    ) {
      edges {
        node {
          ...ProductCardFragment
        }
      }
    }
    mensClothing: allProduct(
      sort: { fields: categories, order: ASC }
      filter: { categories: { regex: "/(?=.*mens)(?=.*suit).*/gi" } }
    ) {
      edges {
        node {
          ...ProductCardFragment
        }
      }
    }
    mens: allProduct(
      sort: { fields: categories, order: ASC }
      filter: { categories: { regex: "/mens/gi" } }
    ) {
      edges {
        node {
          ...ProductCardFragment
        }
      }
    }
  }
`;

// export const pageQuery = graphql`
//   query {
//     allProduct {
//       edges {
//         node {
//           id
//           brand
//           categories
//           colours
//           description
//           name
//           on_sale
//           price {
//             current
//             was
//           }
//           rating
//           reviews {
//             total
//           }
//           sizes
//           sku
//           internal {
//             type
//             contentDigest
//             owner
//           }
//           quantity
//           images {
//             alt_images {
//               low_res
//               high_res
//             }
//           }
//         }
//       }
//     }
//   }
// `;
